import { render, staticRenderFns } from "./custom-edit.component.vue?vue&type=template&id=059345c9&"
import script from "./custom-edit.component.ts?vue&type=script&lang=ts&"
export * from "./custom-edit.component.ts?vue&type=script&lang=ts&"
import style0 from "./custom-edit.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
